import { createBaseOptions, fetchJson, METHOD_PATCH } from "../../utils/SuperAgentFetch";
import { config } from "../../config/Config";

export const fetchUpdateBranding = (json,callback) => {


    /** @type RequestOptions */
    let options = createBaseOptions();
    options.method = METHOD_PATCH;
    options.headers["Content-Type"] = "application/json";
    options["body"] = json;

    let r = fetchJson(`${config.url.API_URL}/branding/custom/item`, options);
    r.then(json => {
        if (json) {
            callback(json);
        }

    }).catch(error => {
        console.log(error);
        // callback(error);
    });
};


